import MultiStepFormV2 from "../components/LancerVisiteForm/MultistepFormV2";

function LancerVisitePage() {
  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <MultiStepFormV2 />
    </div>
  );
}

export default LancerVisitePage;
